import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { routes as autoRoutes } from 'vue-router/auto-routes'
import { useAuthStore } from '@/stores/auth.store'

/**
 * Routes generates by unplugin-vue-router (vite plugin) — virtual module
 * `vue-router/auto-routes` экспортирует readonly-массив. Для совместимости
 * с обычным `createRouter()` приводим к RouteRecordRaw[].
 */

export const router = createRouter({
  history: createWebHistory(),
  routes: autoRoutes as RouteRecordRaw[],
  scrollBehavior(to) {
    if (to.hash) return { el: to.hash, behavior: 'smooth' }
    return { top: 0 }
  },
})

const PUBLIC_ROUTES = new Set(['/login'])
/** Маршруты, доступные только role=admin. */
const ADMIN_ONLY_ROUTES = ['/audit', '/settings', '/users']

router.beforeEach(async (to) => {
  const auth = useAuthStore()
  if (!auth.initialized) {
    await auth.restoreSession()
  }
  const isPublic = PUBLIC_ROUTES.has(to.path)

  if (!auth.isAuthenticated && !isPublic) {
    return { path: '/login', query: { redirect: to.fullPath } }
  }
  if (auth.isAuthenticated && to.path === '/login') {
    return { path: '/' }
  }
  // Admin-only страницы: если зашёл не admin — кидаем на дашборд.
  if (
    auth.isAuthenticated &&
    auth.role !== 'admin' &&
    ADMIN_ONLY_ROUTES.some((p) => to.path === p || to.path.startsWith(p + '/'))
  ) {
    return { path: '/' }
  }
  return true
})
